import { SnackbarOptions } from "react-simple-snackbar";

const commonOptions: SnackbarOptions = {
  style: {
    color: "#fff",
    fontFamily: "Work Sans, sans-serif",
    fontSize: "14px",
    textAlign: "center",
  },
};

export const snackbarSuccessOptions: SnackbarOptions = {
  ...commonOptions,
  position: "bottom-center",
  style: {
    backgroundColor: "#82bea2",
  },
};

export const snackbarWarningOptions: SnackbarOptions = {
  ...commonOptions,
  position: "top-center",
  style: {
    backgroundColor: "#f8943e",
    marginTop: "70px",
  },
};

export const snackbarErrorOptions: SnackbarOptions = {
  ...commonOptions,
  position: "bottom-center",
  style: {
    backgroundColor: "#cc3300",
  },
};

export const MESSAGE_DELETE_OK = "Suppression effectuée";
export const MESSAGE_DELETE_FAILED = "Erreur de suppression";
